import { EditAltIcon } from 'cokitchen-icons';
import React, { useState } from 'react';
import { numberWithCommas } from 'utils/functions';
import EditLevelModal from 'pages/rewards/levels/edit-level-modal';

type LevelProps = {
  id: string;
  title: string;
  max_points: number;
  tier_image: string | null;
  complimentary_meals: { id: string; name: string; images: string[] }[];
  rewards: {
    reward_type: 'Discount' | 'Free Delivery';
    reward_quantity: number;
  }[];
};
const LevelCard = ({
  data,
  addBorderBottom,
  fetchData
}: {
  data: LevelProps;
  addBorderBottom: boolean;
  fetchData: () => Promise<void>;
}) => {
  const [cardHovered, setCardHovered] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const { title, max_points } = data;

  const closeEditLevelModal = (success?: boolean) => {
    setShowEditModal(false);
    if (success) fetchData();
  };

  return (
    <div className={addBorderBottom ? 'border-b border-[#EDEDEE]' : ''}>
      <div
        onMouseEnter={() => setCardHovered(true)}
        onMouseLeave={() => setCardHovered(false)}
        className='bg-[#f7f7f7e6] min-w-full rounded px-[28px] pt-[14px] pb-[14px] flex justify-between items-center'>
        <div>
          <p className='font-medium mb-1'>{title}</p>
          <p className='font-medium text-[#6F7376] text-sm '>
            {numberWithCommas(max_points)} points
          </p>
        </div>

        {cardHovered && (
          <div
            onClick={() => setShowEditModal(true)}
            className='p-2 min-w-fit rounded-full border border-[#E8E8E8]'>
            <EditAltIcon />
          </div>
        )}
      </div>
      {showEditModal && (
        <EditLevelModal show={showEditModal} onClose={closeEditLevelModal} data={data} />
      )}
    </div>
  );
};

export default LevelCard;
